import React from 'react';
export function FlameWatermark({
  className = ''
}: {
  className?: string;
}) {
  return <svg className={`absolute opacity-20 pointer-events-none text-plum ${className}`} viewBox="0 0 100 100" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-339">
      <path d="M50 0C50 0 20 30 20 60C20 76.5685 33.4315 90 50 90C66.5685 90 80 76.5685 80 60C80 30 50 0 50 0ZM50 75C41.7157 75 35 68.2843 35 60C35 45 50 25 50 25C50 25 65 45 65 60C65 68.2843 58.2843 75 50 75Z" data-id="element-340" />
    </svg>;
}